import { render, staticRenderFns } from "./taskWidget.vue?vue&type=template&id=453aeb93&"
import script from "./taskWidget.vue?vue&type=script&lang=js&"
export * from "./taskWidget.vue?vue&type=script&lang=js&"
import style0 from "./taskWidget.vue?vue&type=style&index=0&id=453aeb93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports